import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import api, { getErr } from "../lib/api";
import { NeonButton, NeonCard } from "../components/Neon";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Always neutral response (no account enumeration). Returns a test_code only
      // while live email isn't configured yet (dev/preview).
      const data = await api.post("/auth/forgot-password", { email });
      toast.success("If that email is registered, we've sent a 6-digit reset code.");
      const qs = new URLSearchParams({ email });
      if (data?.test_code) qs.set("code", String(data.test_code));
      navigate(`/reset-password?${qs.toString()}`);
    } catch (err) {
      toast.error(getErr(err, "Could not send reset code"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <NeonCard variant="flow" innerClassName="p-8">
        <Link to="/login" className="flex items-center gap-2 text-sm text-[var(--text-muted)] hover:text-white" data-testid="forgot-back-login"><ArrowLeft className="h-4 w-4" /> Back to login</Link>
        <h1 className="mt-4 font-display uppercase text-4xl text-white glow-white">Reset Password</h1>
        <p className="mt-1 text-sm text-[var(--text-muted)]">Enter your account email and we'll send a 6-digit code to reset your password.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-[var(--text-muted)]">Email</label>
            <input data-testid="forgot-email" type="email" autoComplete="username" spellCheck="false" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-[var(--surface-2)] border border-white/10 rounded-xl px-3 py-2.5 text-white focus:outline-none focus:border-[var(--neon-cyan)]" />
          </div>
          <NeonButton type="submit" variant="pink" className="w-full" data-testid="forgot-submit" loading={loading}>Send Reset Code</NeonButton>
        </form>
        <p className="mt-5 text-sm text-[var(--text-muted)]">Already have a code? <Link to="/reset-password" className="text-[var(--neon-pink)] hover:underline" data-testid="forgot-have-code">Enter it here</Link></p>
      </NeonCard>
    </div>
  );
}
